module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redundant"
  }, [(_vm.item.attr === 'customerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.customerChange
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'originId') ? [_c('el-input', {
    attrs: {
      "disabled": "",
      "readonly": true
    },
    model: {
      value: (_vm.item.attrValue.value),
      callback: function($$v) {
        _vm.$set(_vm.item.attrValue, "value", $$v)
      },
      expression: "item.attrValue.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'contractId') ? [(_vm.form.customerName && _vm.form.customerName.id) ? _c('associated-field', {
    attrs: {
      "module": "contractApi",
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id,
      "multiselect": true
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.relationChange
    }
  }) : _c('span', [_vm._v("无")])] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'paymentId') ? [(_vm.form.contractId && _vm.form.contractId.length === 1) ? _c('div', {
    staticClass: "item-select",
    class: {
      'disable': _vm.item.nonEditable === 1
    }
  }, [(!_vm.form[_vm.item.attr].id && _vm.form[_vm.item.attr].length === 0) ? _c('el-input', {
    attrs: {
      "placeholder": '请点击“选择”添加',
      "readonly": true
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.form[_vm.item.attr]), function(con, i) {
    return _c('span', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(con.value))]), _vm._v(" "), _c('i', {
      staticClass: "del el-icon-close",
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    })])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.contactShow = !_vm.contactShow
      }
    }
  }, [_vm._v("选择")])], 2) : _c('span', [_vm._v("无")]), _vm._v(" "), (_vm.contactShow) ? _c('mult-select', {
    attrs: {
      "module": "payment",
      "contractId": _vm.form.contractId[0].id ? _vm.form.contractId[0].id : '',
      "attrValue": _vm.form[_vm.item.attr]
    },
    on: {
      "emitObj": _vm.relationChange,
      "close": function($event) {
        _vm.contactShow = false
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'userId') ? [_c('v-manager', {
    attrs: {
      "item": _vm.item,
      "form": _vm.form
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcf2e828","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/invoice/index.vue
// module id = 1352
// module chunks = 82